module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [(!_vm.noTerm) ? _c('div', {
    staticClass: "panel"
  }, [(_vm.submissionAssignmentIds) ? _c('div', {
    staticClass: "panel-heading"
  }, [(_vm.alerts && _vm.alerts.length > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.alerts.length))]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Course Alerts"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Find your time sensitive course alerts below'),
      expression: "'Find your time sensitive course alerts below'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle-widget",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [(_vm.open === true) ? _c('i', {
    staticClass: "fa fa-minus"
  }) : _c('i', {
    staticClass: "fa fa-plus"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "panel-body"
  }, [(_vm.localStorage.sinRequested == true && !_vm.sinSubmitted) ? _c('ul', {
    staticClass: "class-alerts sin-alert clearfix"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/sin"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/img/bullhorn.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-text"
  }, [_c('span', {
    staticClass: "alert-name"
  }, [_vm._v("Government Required Information")]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm._f("shortDate")(_vm.sinDueDate))), _c('br')])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.events && _vm.events.length > 0) ? _c('ul', {
    staticClass: "class-alerts clearfix"
  }, _vm._l((_vm.alerts), function(alert) {
    return (alert) ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (alert.type !== 'note' || (alert.type === 'note' && alert.completed !== true)),
        expression: "alert.type !== 'note' || (alert.type === 'note' && alert.completed !== true)"
      }],
      on: {
        "click": function($event) {
          _vm.setWeek(_vm.realCurrentWeek)
        }
      }
    }, [(alert.type === 'assignment' && (_vm.submissionAssignmentIds.indexOf(alert.id) === -1 || alert.resubmission === true)) ? _c('img', {
      attrs: {
        "src": require("./../../assets/img/assignment-icon.png")
      }
    }) : _vm._e(), _vm._v(" "), (alert.type === 'exercise') ? _c('img', {
      attrs: {
        "src": require("./../../assets/img/excercise-icon.png")
      }
    }) : _vm._e(), _vm._v(" "), (alert.type === 'note') ? _c('img', {
      attrs: {
        "src": require("./../../assets/img/assignment-icon.png")
      }
    }) : _vm._e(), _vm._v(" "), (alert.type === 'assignment' && (_vm.submissionAssignmentIds.indexOf(alert.id) === -1 || alert.resubmission === true)) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'videoPlayer',
          params: {
            courseId: alert.courseId,
            instanceId: alert.instanceId,
            videoId: alert.video.id
          },
          query: {
            term: _vm.currentTerm.id,
            week: alert.week,
            tab: 'assignment'
          }
        }
      }
    }, [_c('div', {
      staticClass: "alert-text"
    }, [_c('span', {
      staticClass: "alert-name"
    }, [_vm._v("\n                                " + _vm._s(alert.name) + "\n\n                                ")]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm._f("shortDate")(alert.dueDate))), _c('br'), _vm._v(" "), _c('countdown', {
      attrs: {
        "date": alert.dueDate
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (alert.type === 'exercise') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'videoPlayer',
          params: {
            courseId: alert.exercise.course,
            instanceId: alert.exercise.instanceId,
            videoId: alert.exercise.videoId
          },
          query: {
            term: _vm.currentTerm.id,
            week: _vm.realCurrentWeek,
            tab: 'exercise'
          }
        }
      }
    }, [_c('div', {
      staticClass: "alert-text"
    }, [_c('span', {
      staticClass: "alert-name"
    }, [_vm._v("\n                                " + _vm._s(alert.exercise.title) + "\n                                ")]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm._f("shortDate")(alert.dueDate))), _c('br'), _vm._v(" "), _c('countdown', {
      attrs: {
        "date": alert.dueDate
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (alert.type === 'note') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'mentorDashboard',
          query: {
            note_id: alert.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "alert-text"
    }, [_c('span', {
      staticClass: "alert-name"
    }, [_vm._v("\n                                " + _vm._s(alert.title) + "\n                                ")]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm._f("localShortDate")(alert.dueDate))), _c('br'), _vm._v(" "), _c('countdown', {
      attrs: {
        "date": alert.dueDate,
        "fast": true
      }
    })], 1)]) : _vm._e()], 1) : _vm._e()
  })) : _vm._e(), _vm._v(" "), ((!_vm.events || _vm.events.length === 0) && (!_vm.globalMentors || _vm.globalMentors.length === 0)) ? _c('p', [_vm._v("No course alerts at this time.")]) : _vm._e(), _vm._v(" "), (_vm.courseAlerts && _vm.courseAlerts.length > 0) ? _c('ul', {
    staticClass: "class-alerts clearfix path-alert"
  }, _vm._l((_vm.courseAlerts), function(alert) {
    return _c('li', [_c('a', {
      attrs: {
        "href": alert.link
      }
    }, [_c('img', {
      attrs: {
        "src": require("./../../assets/img/bullhorn.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "alert-text"
    }, [(alert.meetingId) ? _c('span', {
      staticClass: "alert-name"
    }, [_vm._v("Weekly Update")]) : _c('span', {
      staticClass: "alert-name"
    }, [_vm._v(_vm._s(alert.name))]), _c('br'), _vm._v(" "), (alert.meetingId) ? _c('span', [_vm._v(_vm._s(_vm._f("shortDate")(alert.dueDate)))]) : (alert.timeUnit) ? _c('span', [_vm._v(_vm._s(_vm._f("shortDate")(alert.dueDate)))]) : _c('span', [_vm._v(_vm._s(_vm._f("localShortDate")(alert.dueDate)))]), _c('br'), _vm._v(" "), _c('countdown', {
      attrs: {
        "date": alert.dueDate,
        "fast": true
      }
    })], 1)])])
  })) : _vm._e(), _vm._v(" "), (_vm.checkins && _vm.checkins.length > 0) ? _c('ul', {
    staticClass: "class-alerts clearfix path-alert"
  }, _vm._l((_vm.checkins), function(checkin) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'mentorCheckins',
          query: {
            id: checkin.id
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("./../../assets/img/bullhorn.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "alert-text"
    }, [(checkin.meetingId === 0) ? _c('span', {
      staticClass: "alert-name"
    }, [_vm._v("Check-in for " + _vm._s(_vm._f("monthAndDay")(checkin.dueDate)))]) : _c('span', {
      staticClass: "alert-name"
    }, [_vm._v("Check-in for Week " + _vm._s(checkin.week))]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm._f("checkinDate")(checkin.dueDate))), _c('br'), _vm._v(" "), (_vm.isOverdue(checkin.dueDate)) ? _c('span', {
      staticClass: "overdue"
    }, [_vm._v("Overdue")]) : _c('countdown', {
      attrs: {
        "date": checkin.dueDate,
        "fast": true
      }
    })], 1)])], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.taMeetings && _vm.taMeetings.length) ? _c('ul', {
    staticClass: "ta-meetings clearfix"
  }, _vm._l((_vm.taMeetings), function(meeting) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectedTAMeeting = meeting.id
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("./../../assets/img/bullhorn.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "alert-text"
    }, [_c('span', {
      staticClass: "alert-name",
      class: {
        'blue': _vm.isParticipant(meeting.ta_meeting_participants)
      }
    }, [_c('span', [_vm._v("TA Session, Week " + _vm._s(meeting.week) + ", with ")]), _vm._v("\n                                   " + _vm._s(meeting.ta.firstName) + " " + _vm._s(meeting.ta.lastName)), _c('br')]), _vm._v(" "), _c('span', {
      staticClass: "alert-name",
      class: {
        'red': meeting.ta_meeting_participants.length >= meeting.maxParticipants
      }
    }, [_vm._v("\n                                       " + _vm._s(meeting.ta_meeting_participants.length) + " / " + _vm._s(meeting.maxParticipants) + "\n                                   ")]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm._f("shortDate")(meeting.startTime))), _c('br'), _vm._v(" "), _c('countdown', {
      attrs: {
        "date": meeting.startTime,
        "fast": true
      }
    })], 1)])])
  })) : _vm._e(), _vm._v(" "), (_vm.globalMentors && _vm.globalMentors.length > 0) ? _c('ul', {
    staticClass: "class-alerts clearfix path-alert"
  }, _vm._l((_vm.globalMentors), function(mentor) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectedGlobalMeeting = mentor.global_meeting.id
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("./../../assets/img/bullhorn.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "alert-text"
    }, [_c('span', {
      staticClass: "alert-name",
      class: {
        'blue': _vm.isParticipant(mentor.global_meeting.global_meeting_participants)
      }
    }, [(mentor.roles.includes('Recruiter')) ? _c('span', [_vm._v("Recruiter Meeting, ")]) : _c('span', [_vm._v("Global Mentorship, ")]), _vm._v("\n                                   " + _vm._s(mentor.firstName) + " " + _vm._s(mentor.lastName) + ",  "), (mentor.roles.includes('Recruiter')) ? _c('span', [_vm._v(_vm._s(mentor.global_mentor_profile.company))]) : _c('span', [_vm._v(_vm._s(mentor.mentor_profile.position))])]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "alert-name",
      class: {
        'red': mentor.global_meeting.global_meeting_participants.length >= mentor.global_meeting.maxParticipants
      }
    }, [_vm._v("\n                                       " + _vm._s(mentor.global_meeting.global_meeting_participants.length) + " / " + _vm._s(mentor.global_meeting.maxParticipants) + "\n                                   ")]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm._f("shortDate")(mentor.global_meeting.startTime))), _c('br'), _vm._v(" "), _c('countdown', {
      attrs: {
        "date": mentor.global_meeting.startTime,
        "fast": true
      }
    })], 1)])])
  })) : _vm._e()])]) : _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.selectedGlobalMeeting) ? _c('global-meeting-signup', {
    attrs: {
      "meetingId": _vm.selectedGlobalMeeting
    },
    on: {
      "closeModal": function($event) {
        _vm.selectedGlobalMeeting = null;
        _vm.getGlobalMeetings()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTAMeeting) ? _c('ta-meeting-signup', {
    attrs: {
      "meetingId": _vm.selectedTAMeeting
    },
    on: {
      "closeModal": function($event) {
        _vm.selectedTAMeeting = null;
        _vm.getTAMeetings()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Class Alerts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("Term has not yet started")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14aa2815!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ClassAlerts.vue
// module id = 1981
// module chunks = 2